import { ColorInterval } from "../popup/flight-inspection-style/flight-inspection-style.component";

export class ImportCSVTableFieldModel {
  required: boolean = false;
  checked: boolean = false;
  name : string;
  index : string;
  units?: string;

  constructor(name : string, index : string, required: boolean = false, checked: boolean = true, units?: string){
    this.required = required;
    this.checked = checked;
    this.name = name;
    this.index = index;
    this.units = units;
  }

  static getLetterFromTable(element : string, table: ImportCSVTableFieldModel[]): string {
    for(var i = 0; i < table.length; i++){
      if(element == table[i].name){
        return table[i].index;
      }
    }
    return "";
  }

  static getCheckedFromTable(element : string, table: ImportCSVTableFieldModel[]): boolean {
    for(var i = 0; i < table.length; i++){
      if(element == table[i].name){
        return table[i].checked;
      }
    }
    return false;
  }

  static getRequiredFromTable(element : string, table: ImportCSVTableFieldModel[]): boolean {
    for(var i = 0; i < table.length; i++){
      if(element == table[i].name){
        return table[i].required;
      }
    }
    return false;
  }
  static lettersToNumber(letters): number {
    for(var p = 0, n = 0; p < letters.length; p++){
        n = letters[p].charCodeAt() - 64 + n * 26;
    }
    n--;
    return n;
}

  static convertLetterToNumber(str : string): number {
    var out = 0, len = str.length;
    for (var pos = 0; pos < len; pos++) {
      out += (str.toLowerCase().charCodeAt(pos) - 97) + (26 * (len-pos-1));
    }
    return out;
  }
}
export class FlightInspectionCSVFields extends ImportCSVTableFieldModel{
  units: string;
  hasStyle: boolean;
  style: ColorInterval[] = [];
  key: string;
  navaidID: string;
  constructor(key:string,name : string, units:string , index : string, hasStyle:boolean=false , required: boolean = false, checked: boolean = true,style?:ColorInterval[]){
    super(name,index,required,checked);
    this.units = units;
    this.hasStyle = hasStyle;
    this.style = style;
    this.key = key;
  }
}


